// Licensing contact details.
//
// The page is static by design — the visitor's mail client is the transport.
// No form element, no handler, no fetch. A hosted form provider can replace
// ContactBlock later without touching anything around it.

export const LICENSING_EMAIL = 'deeporbai@gmail.com';

const SUBJECT = 'Katbot licensing enquiry';

// Prefilled skeleton so the first reply can be a useful one. Body prefill
// support varies by mail client (Gmail web and Apple Mail honour it; some
// Outlook configurations drop it), which is why the prompts are also printed
// on the page.
const BODY = [
  'Company:',
  "What you'd use it for:",
  "Where you'd deploy (AWS / GCP / Azure / on-prem):",
  'Expected users:',
  'Timeline:',
  'Anything else:',
  '',
].join('\n');

export const LICENSING_MAILTO =
  `mailto:${LICENSING_EMAIL}` +
  `?subject=${encodeURIComponent(SUBJECT)}` +
  `&body=${encodeURIComponent(BODY)}`;

// Subject-only variant for the hero, where a full skeleton is premature.
export const LICENSING_MAILTO_SHORT =
  `mailto:${LICENSING_EMAIL}?subject=${encodeURIComponent(SUBJECT)}`;
